"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-cancel.js
var Cancel = function Cancel(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M8.00065 1.33334C4.31398 1.33334 1.33398 4.31334 1.33398 8.00001C1.33398 11.6867 4.31398 14.6667 8.00065 14.6667C11.6873 14.6667 14.6673 11.6867 14.6673 8.00001C14.6673 4.31334 11.6873 1.33334 8.00065 1.33334ZM11.334 10.3933L10.394 11.3333L8.00065 8.94001L5.60732 11.3333L4.66732 10.3933L7.06065 8.00001L4.66732 5.60668L5.60732 4.66668L8.00065 7.06001L10.394 4.66668L11.334 5.60668L8.94065 8.00001L11.334 10.3933Z"
  }));
};

var _default = Cancel;
exports.default = _default;